import React from "react"
import { DataGrid } from "@mui/x-data-grid";
import { useDispatch, useSelector } from "react-redux";

import { useEffect, useState, useMemo } from "react";
import Box from "@mui/material/Box";
import { Button, Grid, Typography } from "@mui/material";
import { BoxStyle, HeaderStyle, ButtonStyle } from "./style";
import CustomPagination from "../../../components/CustomPagination";
import { CustomConfirmPopup } from "../../../components/CustomPopups/ConfirmPopup/CustomConfirmPopup";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import setLoader from "../../../components/CustomLoader/loaderState";
import CustomModal from "../../../components/CustomModalPop";
import Columns from "./columnsDef";
import RequirementPendingItemForm from "./RequirementPendingItemForm";
import {
  deleteRequirementPendingItemsDetails,
  getRequirementPendingItems,
} from "../../../store/actions/Requirement";
import { deleteTaskPendingItems, getTaskPendingItems } from "../../../store/actions/Task";
import ViewForm from "../../Register/viewPage";
import { ProfileType } from "../../../utility/commonTypes";

const RequirementPendingItems = () => {
  const dispatch = useDispatch();
  const [rowData, setRowData] = useState<any>([]);
  const [currentPageNo, setCurrentpageNo] = useState<number>(0);
  const [totalPageCount, setTotalPageCount] = useState<any>(0);
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [openModalPop, setOpenModalPop] = useState<any>(false);
  const [selectedRowId, setRowId] = useState("");
  const [selectedTaskId, setTaskId] = useState("");
  const [deleteSuccessPopup, setDeleteSuccessPopUp] = useState(false);
  const[openUserDetailsPopUp,setOpenUserDetailsPopUp]=useState(false)
  const[userId,setUserId]=useState("")
  const params: any = useParams();
  const stateData = params;
  const getProfileType = useSelector((store: any) => {
    return store.auth?.globalAuthData?.usertype;
  });
  const isEditable = useSelector((store: any) => {
    return store?.taskDetails?.taskEditable?.[stateData?.taskId];
  });

  const handleClickOpen = () => {
    setLoader(true);
    setOpenModalPop(true);
    setLoader(false);
    setRowId("");
  };
  const location = useLocation();
  const fetchRequirementPendingItemsList = (
    pageNumber: number,
    buttonType?: string
  ) => {
    try {
      setLoading(true);
      dispatch(
        getTaskPendingItems(
          {
            id: stateData?.taskId,
            size: 10,
            page: pageNumber,
          },
          (data: any) => {
            setTotalPageCount(data?.totalItems);
            if (data?.rowsReturned?.length > 0) {
              let newRowReturned: any = data?.rowsReturned.map(
                (item: any, i: number) => {
                  item["fieldId"] = i;
                  return item;
                }
              );
              setRowData(newRowReturned);
            } else {
              setRowData([]);
            }
          }
        )
      );
    } catch (e) {
      console.log(e, "error");
    } finally {
      if (buttonType === "NEXT_PAGE") {
        setCurrentpageNo(pageNumber);
      } else {
        setCurrentpageNo(0);
      }
      setLoading(false);
    }
  };
  console.log("row count", totalPageCount);
  const [successPopup, setSuccessPopup] = useState(false);

  const onClickYes = (rowId: any,taskId:any) => {
    setDeletePopUp(false);
    setLoader(true);

    dispatch(
      deleteTaskPendingItems(
        { id: rowId,task_id:taskId },
        function (res: any) {
          setLoader(false);
          // setSuccessPopup(true);
          setDeleteSuccessPopUp(true);
          setTimeout(()=>{
            setDeleteSuccessPopUp(false);
      
          },5000)
          fetchRequirementPendingItemsList(0, "ON_LOAD")
        }
      )
    );
  };
  const onClickNo = () => {
    setDeletePopUp(false);
  };

  useEffect(() => {
    fetchRequirementPendingItemsList(0, "ON_LOAD");
    // getProjectResources()
  }, []);

  const [deletePopUp, setDeletePopUp] = useState(false);

  const deleteRequirementPendingItems = (event: any, id: any) => {
    setDeletePopUp(true);
    // setTimeout(()=>{
    //   setDeleteSuccessPopUp(false);

    // },5000)
    setRowId(id);
  };

  const editRequirementPendingItems = (event: any, id: any) => {
    console.log("id is", id);
    setOpenModalPop(true);
    setRowId(id);
  };
  const handleUserDetails=(event:any,id:any)=>{
    setOpenUserDetailsPopUp(true)
    setUserId(id)
  }
  const defaultColumns = useMemo(() => {
    return Columns(editRequirementPendingItems, deleteRequirementPendingItems,handleUserDetails);
  }, []);

  const handleClose = () => {
    setOpenModalPop(false);
    setRowId("");
  };
  const onPendingItemSuccess = () => {
    fetchRequirementPendingItemsList(0, "ON_LOAD");
    setSuccessPopup(true);
    setTimeout(()=>{
      setSuccessPopup(false);

    },5000)

  };
  return (
    <>
      <Grid container direction="row" justifyContent={"space-between"}>
        <Typography sx={HeaderStyle} className="my-4 mx-4">
          Pending Items
        </Typography>
        <div className="my-4 mx-4">
        {((ProfileType?.USER === getProfileType || ProfileType?.CUSTOMER === getProfileType) && isEditable) || ProfileType?.ADMIN === getProfileType ? 
   <Button
            variant="contained"
            onClick={handleClickOpen}
            size="medium"
            className="py-2"
            sx={ButtonStyle}
          >
            Add
          </Button>:null}
        </div>
      </Grid>
      <Box sx={BoxStyle}>
        <DataGrid
          autoHeight
          rows={rowData}
          rowCount={totalPageCount}
          page={currentPageNo}
          columns={defaultColumns}
          pageSize={10}
          disableSelectionOnClick
          disableColumnMenu
          pagination
          paginationMode="server"
          loading={loading}
          components={{
            Pagination: CustomPagination,
          }}
          onPageChange={(data) => {
            fetchRequirementPendingItemsList(data, "NEXT_PAGE");
          }}
        />
      </Box>

      {openModalPop && (
        <RequirementPendingItemForm
          row={selectedRowId}
          onPendingItemSuccess={onPendingItemSuccess}
          handleClose={handleClose}
          openModalPop={openModalPop}
          setOpenModalPop={setOpenModalPop}
        />
      )}
 {((ProfileType?.USER === getProfileType || ProfileType?.CUSTOMER === getProfileType) && isEditable) || ProfileType?.ADMIN === getProfileType? 

      <CustomConfirmPopup
        open={deletePopUp}
        close={() => {
          setDeletePopUp(false);
        }}
        closeAndSubmit={() => {}}
        onClickYes={onClickYes}
        rowId={selectedRowId}
        onClickNo={onClickNo}
        title={`Delete Pending Item`}
        btnText={`${"Yes"}`}
        btnText1={`${"No"}`}
        description={`Are you sure you want to delete the selected pending item`}
        // successIcon={true}
      />:null}
      <CustomModal
        title="Pending Items"
        onOpen={successPopup}
        content={"Requirement Created/Updated Successfully"}
        modalType={"success"}
        width={"sm"}
        OnClickCloseIcon={() => {
          setSuccessPopup(false);
        }}
      />
      <CustomModal
        title="Pending Items"
        onOpen={deleteSuccessPopup}
        content={"Requirement Deleted Successfully"}
        modalType={"success"}
        width={"sm"}
        OnClickCloseIcon={() => {
          setDeleteSuccessPopUp(false);
        }}
      />
       <CustomModal
            title="Details"
            height="80%"
            width="md"
             onOpen={openUserDetailsPopUp}
            customWidth="750px"
            backgroundColor="#E1E1E1"
            content={<ViewForm userId={userId} setOpenUserDetailsPopUp={setOpenUserDetailsPopUp}/>}
            OnClickCloseIcon={() => {
              setOpenUserDetailsPopUp(false);
            }}
          />
    </>
  );
};
export default RequirementPendingItems;
